(() => {
    const IMAGE_WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];

    // Swatches carry one CDN url; Shopify resizes on the width param, so build the srcset from it
    function buildSrcset(url) {
        return IMAGE_WIDTHS.map((width) => {
            const sized = new URL(url, window.location.href);
            sized.searchParams.set("width", width);
            return `${sized.href} ${width}w`;
        }).join(", ");
    }

    function setImage(image, url, alt) {
        image.src = url;
        image.srcset = buildSrcset(url);
        image.alt = alt || "";
    }

    function updateImages(productCard, swatch) {
        const image1 = swatch.getAttribute("data-image-1");
        const image2 = swatch.getAttribute("data-image-2");
        const alt1 = swatch.getAttribute("data-alt-1");
        const alt2 = swatch.getAttribute("data-alt-2");

        const primaryImage = productCard.querySelector(".product-card__image--primary");
        const secondaryImage = productCard.querySelector(".product-card__image--secondary");

        if (primaryImage && image1) {
            setImage(primaryImage, image1, alt1);
        }

        if (secondaryImage && (image2 || image1)) {
            setImage(secondaryImage, image2 || image1, image2 ? alt2 : alt1);
        }
    }

    function updatePrice(productCard, swatch) {
        const template = swatch.querySelector(".price-template");
        const price = productCard.querySelector(".product-card__price");

        if (template && price) {
            price.innerHTML = template.innerHTML;
        }
    }

    function updateBadges(productCard, swatch) {
        const template = swatch.querySelector(".badges-template");
        const badges = productCard.querySelector(".product-card__badges");

        if (template && badges) {
            badges.innerHTML = template.innerHTML;
        }
    }

    function updateCardMeta(productCard, swatch) {
        const productUrl = swatch.getAttribute("data-product-url");
        const productHandle = swatch.getAttribute("data-product-handle");
        const productID = swatch.getAttribute("data-product-id");
        const color = swatch.getAttribute("data-color");
        const variantID = swatch.getAttribute("data-first-variant-id");
        const available = swatch.getAttribute("data-available") === "true";

        if (productUrl) {
            productCard.querySelectorAll('a[href*="/products/"]').forEach((link) => {
                link.href = productUrl;
            });
        }

        const colorNameEl = productCard.querySelector(".product-card__color");
        if (colorNameEl && color) {
            colorNameEl.textContent = color;
        }

        // a color can be a differently named product (e.g. a Leo print next to plain colors)
        const titleLink = productCard.querySelector(".product-card__title a");
        const title = swatch.getAttribute("data-title");
        if (titleLink && title) {
            titleLink.textContent = title;
        }

        // wishlist
        const wishlistBtn = productCard.querySelector(".wishlist-collection-button button");
        if (wishlistBtn && productHandle) {
            wishlistBtn.setAttribute("data-product-handle", productHandle);
        }

        // wishlist, hidden while the shown color is tagged hide-add-to-cart
        const wishlist = productCard.querySelector(".wishlist-collection-button");
        if (wishlist) {
            wishlist.hidden = swatch.getAttribute("data-hide-add-to-cart") === "true";
        }

        // quick buy, hidden while the shown color is sold out
        const quickBuy = productCard.querySelector(".product-card__quick-buy");
        if (quickBuy) {
            quickBuy.hidden = !available;
        }

        // the drawer moves itself to <body> on first open, so find it by id rather than inside the card
        const drawerId = productCard.querySelector(".product-card__quick-buy [aria-controls]")?.getAttribute("aria-controls");
        const quickBuyDrawer = drawerId && document.getElementById(drawerId);
        if (quickBuyDrawer && variantID) {
            quickBuyDrawer.setAttribute("handle", `${productHandle}?variant=${variantID}`);

            // QuickBuyDrawer (theme.js) caches its content after the first open; clear it so the new color is fetched
            quickBuyDrawer._hasLoaded = false;
        }

        const variantInput = productCard.querySelector(".product-card__quick-buy form input[name='id']");
        if (variantInput && variantID) {
            variantInput.value = variantID;
        }

        // recommendations popup
        const recommendationsPopup = productCard.querySelector("product-recommendations-popup");
        if (recommendationsPopup && productID && recommendationsPopup.getAttribute("product") !== productID) {
            recommendationsPopup.setAttribute("product", productID);

            // the popup (theme.js) loads once, on the first hover of the card; mark it stale so it reloads for this color
            recommendationsPopup._isLoaded = false;
        }
    }

    function applySwatchState(productCard, swatch, swatches) {
        if (swatch.classList.contains("selected")) return;

        swatches.forEach((s) => {
            s.classList.remove("selected");
            s.setAttribute("aria-pressed", "false");
        });
        swatch.classList.add("selected");
        swatch.setAttribute("aria-pressed", "true");

        updateImages(productCard, swatch);
        updatePrice(productCard, swatch);
        updateBadges(productCard, swatch);
        updateCardMeta(productCard, swatch);
    }

    function initCard(productCard) {
        if (productCard.hasAttribute("data-swatches-initialized")) return;
        productCard.setAttribute("data-swatches-initialized", "true");

        const container = productCard.querySelector(".product-card__colors");
        if (!container) return;

        const swatches = Array.from(container.querySelectorAll(".product-card__swatch"));

        // reload stale recommendations when quick buy opens, so they are ready when the item is added
        productCard.querySelector(".product-card__quick-buy")?.addEventListener("click", () => {
            productCard.querySelector("product-recommendations-popup")?.loadOnDemand?.();
        });

        // The card is server-rendered with the selected color, so nothing to apply on load
        swatches.forEach((swatch) => {
            swatch.addEventListener("mouseenter", () => applySwatchState(productCard, swatch, swatches));

            swatch.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                applySwatchState(productCard, swatch, swatches);
            });
        });
    }

    function initAllCards() {
        document.querySelectorAll("product-card").forEach(initCard);
    }

    // MutationObserver — picks up cards added by infinite scroll
    function observeNewCards() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return;
                    if (node.matches("product-card")) initCard(node);
                    node.querySelectorAll("product-card").forEach(initCard);
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    function boot() {
        initAllCards();
        observeNewCards();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
    } else {
        boot();
    }
})();
